/* eslint no-undef: "error" */

import React, { useState, useEffect } from "react";
import { object, array, string, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import StoryTitleInfo from "../../molecules/StoryTitleInfo";
import StoryContent from "../../molecules/StoryContent";
import StoryPageMetaData from "../../molecules/StoryPageMetaData";
import DfpAd from "../../dfp-ad";

import "./blank.m.css";

const BlankStoryTemplate = ({
  story,
  summary,
  relatedStories,
  imageElements,
  startingCard,
  publisherAttributes,
  jwtToken,
}) => {
  const slicedStoryCards = story.cards.slice(startingCard);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName="wrapper" data-testid="related-story">
      <div styleName="ad-slot" className="top-ad">
        <DfpAd
          adtype={publisherAttributes === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}
          targetStory={story}
          slotId={`${publisherAttributes.lang === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}-${story.id.slice(
            -5
          )}-top-ad`}
        />
      </div>
      <div styleName="meta-content" className="print-meta-content">
        <div>
          <StoryTitleInfo
            story={story}
            summary={summary}
            datatrackingcategory="Story Sub Section"
            datatrackingaction="Click"
          />
          <StoryPageMetaData story={story} lang={publisherAttributes.lang} />
        </div>
        {typeof window !== "undefined" && !isMobile && (
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
            targetStory={story}
            slotId={`${
              publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"
            }-${story.id.slice(-5)}-r1-ad`}
          />
        )}
      </div>
      <StoryContent
        story={story}
        slicedStoryCards={slicedStoryCards}
        relatedStories={relatedStories}
        imageElements={imageElements}
        showMetadata={false}
        isMobile={isMobile}
        jwtToken={jwtToken}
        datatrackingcategory="Story Sub Section"
        datatrackingaction="Click"
      />
    </div>
  );
};

const BlankStory = ({
  story,
  relatedStories,
  summary,
  imageElements,
  startingCard,
  publisherAttributes,
  jwtToken,
  storyIndex,
}) => {
  return (
    <div className="story-grid">
      <BlankStoryTemplate
        story={story}
        relatedStories={relatedStories}
        summary={summary}
        imageElements={imageElements}
        startingCard={startingCard}
        publisherAttributes={publisherAttributes}
        jwtToken={jwtToken}
        storyIndex={storyIndex}
      />
    </div>
  );
};

BlankStoryTemplate.propTypes = {
  story: object,
  relatedStories: array,
  summary: string,
  imageElements: array,
  startingCard: number,
  publisherAttributes: object,
  jwtToken: string,
  storyIndex: string,
};

BlankStory.propTypes = {
  story: object,
  relatedStories: array,
  summary: string,
  imageElements: array,
  startingCard: number,
  publisherAttributes: object,
  jwtToken: string,
  storyIndex: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  storyIndex: get(state, ["headerReducer", "showStoryHeader", "storyIndex"], "0"),
});

export default connect(mapStateToProps, null)(BlankStory);
